import { httpGatewayService } from '@/modules/common/services';

const availabilitySlotsRoute = 'v3/scheduling/availability_slots';

/**
 * Fetches availability slots for scheduling based on specified criteria.
 * At least one of resource_type_uids, resource_uids, or staff_uids must be provided.
 * 
 * @param {Array<string>} [params.resource_type_uids] - Array of resource type UIDs
 * @param {Array<string>} [params.resource_uids] - Array of resource UIDs  
 * @param {Array<string>} [params.staff_uids] - Array of staff UIDs
 * @param {string} [params.start_time] - Start time for availability (ISO format)
 * @param {string} [params.end_time] - End time for availability (ISO format)
 * @param {string} [params.timezone] - Timezone for the availability slots
 * @param {number} [params.slot_duration] - Duration in minutes for the slots
 */
const getAvailabilitySlots = async (params = {}) => {
  try {
    const { resource_type_uids, resource_uids, staff_uids } = params;
    if (!resource_type_uids?.length && !resource_uids?.length && !staff_uids?.length) {
      throw new Error('At least one of resource_type_uids, resource_uids, or staff_uids must be provided');
    }

    const response = await httpGatewayService.get(availabilitySlotsRoute, params);

    return response.data?.availability_slots;
  } catch (error) {
    console.error('Error fetching availability slots:', error);
    throw error;
  }
};

export default {
  getAvailabilitySlots,
};
